import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import api from "@/lib/api";
import { Loader } from "@/components/Loader";

export default function Categories() {
  const [categories, setCategories] = useState(null);
  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)).catch(() => setCategories([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <p className="eyebrow text-primary">Navegue por tipo de móvel</p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight">Categorias</h1>
      <p className="mt-2 text-muted-foreground">Encontre projetos organizados por tipo.</p>

      {categories === null ? <Loader /> : (
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((c) => {
            const Icon = Icons[c.icon] || Icons.Boxes;
            return (
              <Link key={c.slug} to={`/explorar?category=${c.slug}`} data-testid={`cat-page-${c.slug}`}
                className="group flex items-center gap-4 rounded-2xl border border-border bg-card p-5 hover-lift">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-secondary text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <Icon className="h-6 w-6" />
                </span>
                <div>
                  <p className="font-bold">{c.name}</p>
                  <p className="text-xs text-muted-foreground">{c.count} projeto(s)</p>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
